import withTabView from '../TabView'

const routes = [
  {
    path: '/independentOnlinePayment',
    component: withTabView(
      require('@fishx/runtime').dynamic({
        loader: () =>
          import(
            /* webpackChunkName: 'layouts__OnlinePayment' */ '../../layouts/OnlinePayment'
          ),
        loading: require('@/components/Loading').default,
      }),
    ),
    routes: [
      {
        exact: true,
        title: 'OnlinePayment',
        path: '/independentOnlinePayment/paymentMethod',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__OnlinePayment__PaymentMethod' */ '../../pages/OnlinePayment/PaymentMethod'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        exact: true,
        title: 'OnlinePayment',
        path: '/independentOnlinePayment/billingInformation',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__OnlinePayment__BillingInformation' */ '../../pages/OnlinePayment/BillingInformation'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        exact: true,
        title: 'OnlinePayment',
        path: '/independentOnlinePayment/paymentResult',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__OnlinePayment__PaymentResult' */ '../../pages/OnlinePayment/PaymentResult'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        exact: true,
        title: 'OnlinePayment',
        path: '/independentOnlinePayment/queryBillingInformation',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__OnlinePayment__QueryBillingInformation' */ '../../pages/OnlinePayment/QueryBillingInformation'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        exact: true,
        title: 'OnlinePayment',
        path: '/independentOnlinePayment/ReceiptCaptcha',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__OnlinePayment__ReceiptCaptcha' */ '../../pages/OnlinePayment/ReceiptCaptcha'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        exact: true,
        title: 'OnlinePayment',
        path: '/independentOnlinePayment/ReceiptResult',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__OnlinePayment__ReceiptResult' */ '../../pages/OnlinePayment/ReceiptResult'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        exact: true,
        title: 'OnlinePayment',
        path: '/independentOnlinePayment/ReceiptPdfView',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__OnlinePayment__ReceiptPdfView' */ '../../pages/OnlinePayment/ReceiptPdfView'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
    ],
  },
  {
    path: '/payment',
    component: withTabView(
      require('@fishx/runtime').dynamic({
        loader: () =>
          import(
            /* webpackChunkName: 'layouts__OnlinePayment' */ '../../layouts/OnlinePayment'
          ),
        loading: require('@/components/Loading').default,
      }),
    ),
    routes: [
      {
        path: '/payment/:uid',
        exact: true,
        title: 'OnlinePayment',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__OnlinePayment__BillingInformation' */ '../../pages/OnlinePayment/BillingInformation'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/payment',
        exact: true,
        title: 'OnlinePayment',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__OnlinePayment__BillingInformation' */ '../../pages/OnlinePayment/BillingInformation'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
    ],
  },
  {
    path: '/queryReceipt',
    component: withTabView(
      require('@fishx/runtime').dynamic({
        loader: () =>
          import(
            /* webpackChunkName: 'layouts__OnlinePayment' */ '../../layouts/OnlinePayment'
          ),
        loading: require('@/components/Loading').default,
      }),
    ),
    routes: [
      {
        path: '/queryReceipt',
        exact: true,
        title: 'OnlinePayment',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__OnlinePayment__ReceiptCaptcha' */ '../../pages/OnlinePayment/ReceiptCaptcha'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
    ],
  },
  {
    path: '/',
    component: require('@fishx/runtime').dynamic({
      loader: () => import(/* webpackChunkName: 'layouts' */ '../../layouts'),
      loading: require('@/components/Loading').default,
    }),
    routes: [
      {
        path: '/',
        exact: true,
        component: require('@fishx/runtime').dynamic({
          loader: () =>
            import(/* webpackChunkName: 'p__index' */ '../../pages/index'),
          loading: require('@/components/Loading').default,
        }),
      },
      {
        path: '/componentMgr',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__ComponentMgr' */ '../../pages/ComponentMgr'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
        exact: true,
      },
      {
        path: '/logMgr',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(/* webpackChunkName: 'p__LogMgr' */ '../../pages/LogMgr'),
            loading: require('@/components/Loading').default,
          }),
        ),
        exact: true,
      },
      {
        path: '/menuMgr',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__MenuMgr' */ '../../pages/MenuMgr'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
        exact: true,
      },
      {
        path: '/iframeModule/:index',
        component: require('@fishx/runtime').dynamic({
          loader: () =>
            import(
              /* webpackChunkName: 'p__IframeModule' */ '../../pages/IframeModule'
            ),
          loading: require('@/components/Loading').default,
        }),
        exact: true,
      },
      {
        path: '/DynamicModule/:index',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__DynamicModule' */ '../../pages/DynamicModule'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
        exact: true,
      },
      {
        path: '/mvnoMgr',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__MvnoMgr' */ '../../pages/MvnoMgr'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
        exact: true,
      },
      {
        path: '/mvnoUserMgr',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__MvnoUserMgr' */ '../../pages/MvnoUserMgr'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
        exact: true,
      },
      {
        path: '/portalMgr',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__PortalMgr' */ '../../pages/PortalMgr'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
        exact: true,
      },
      {
        path: '/portletMgr',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__PortletMgr' */ '../../pages/PortletMgr'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
        exact: true,
      },
      {
        path: '/Profile',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__Profile' */ '../../pages/Profile'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
        exact: true,
      },
      {
        path: '/roleMgr',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__RoleMgr' */ '../../pages/RoleMgr'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
        exact: true,
      },
      {
        path: '/sysParamMgr',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__SysParamMgr' */ '../../pages/SysParamMgr'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
        exact: true,
      },
      {
        path: '/userMgr',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__UserMgr' */ '../../pages/UserMgr'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
        exact: true,
      },
      {
        path: '/userLogin',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__BSNLUserLogin' */ '../../pages/BSNLUserLogin'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
        exact: true,
      },
      {
        path: '/Dashboard',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(/* webpackChunkName: 'p__Home' */ '../../pages/Home'),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/flowDemo',
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__FlowDemo' */ '../../pages/FlowDemo'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
        exact: true,
      },
      {
        path: '/browserAnalysisMgr',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__BrowserAnalysisMgr' */ '../../pages/BrowserAnalysisMgr'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/oauth2ClientMgr',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__Oauth2ClientMgr' */ '../../pages/Oauth2ClientMgr'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/indicatorRequest',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__IndicatorRequest' */ '../../pages/IndicatorRequest'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/newConnection',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__NewConnection' */ '../../pages/NewConnection'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/reconnection',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__Reconnection' */ '../../pages/Reconnection'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/disconnection',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__Disconnection' */ '../../pages/Disconnection'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/casualExtension',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__CasualExtension' */ '../../pages/CasualExtension'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/modifyPlan',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__ModifyPlan' */ '../../pages/ModifyPlan'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/modifyFeature',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__ModifyFeature' */ '../../pages/ModifyFeature'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/changeOfIndicatorNormal',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__ChangeOfIndicatorNormal' */ '../../pages/ChangeOfIndicatorNormal'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/changeOfIndicatorISDN',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__ChangeOfIndicatorISDN' */ '../../pages/ChangeOfIndicatorISDN'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/virtualConvertToFixedLine',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__VirtualConvertToFixedLine' */ '../../pages/VirtualConvertToFixedLine'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/ttOrder',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__TTOrder' */ '../../pages/TTOrder'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/salesOrderMgr',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__SalesOrderMgr' */ '../../pages/SalesOrderMgr'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/modifyingFixedLineNumberGroup',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__ModifyingFixedLineNumberGroup' */ '../../pages/ModifyingFixedLineNumberGroup'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/transfer',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__Transfer' */ '../../pages/Transfer'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/virtualChangeOfDestinationNumber',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__VirtualChangeOfDestinationNumber' */ '../../pages/VirtualChangeOfDestinationNumber'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/modifyBroadbandNetworkIP',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__ModifyBroadbandNetworkIP' */ '../../pages/ModifyBroadbandNetworkIP'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/shift',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(/* webpackChunkName: 'p__Shift' */ '../../pages/Shift'),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/modifyForService',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__ModifyForService' */ '../../pages/ModifyForService'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/modifyGoods',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__ModifyGoods' */ '../../pages/ModifyGoods'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/addServices',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__AddServices' */ '../../pages/AddServices'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/manageExtension',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__ManageExtension' */ '../../pages/ManageExtension'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/assignMembersArea',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__AssignAreaToMembers' */ '../../pages/AssignAreaToMembers'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/billPayment',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__BillPayment' */ '../../pages/BillPayment'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/leadsManagement',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__LeadsManagement' */ '../../pages/LeadsManagement'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/customerAccount',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__CustomerAccount' */ '../../pages/CustomerAccount'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/customerAccountProfile',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__CustomerAccountProfile' */ '../../pages/CustomerAccountProfile'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/commissionQuery',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__CommissionQuery' */ '../../pages/CommissionQuery'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/appealRecordQuery',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__AppealRecordQuery' */ '../../pages/AppealRecordQuery'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/billDesk',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__BillDesk' */ '../../pages/BillDesk'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/ftthConversions',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__FTTHConversions' */ '../../pages/FTTHConversions'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
      {
        path: '/:privCode',
        exact: true,
        component: withTabView(
          require('@fishx/runtime').dynamic({
            loader: () =>
              import(
                /* webpackChunkName: 'p__OuterSystemPage' */ '../../pages/OuterSystemPage'
              ),
            loading: require('@/components/Loading').default,
          }),
        ),
      },
    ],
  },
]

export default routes
